import { Link } from "react-router-dom";

interface QuickLink {
  title: string;
  desc: string;
  count: string;
  to: string;
  icon: string;
  image: string;
}

const quickLinks: QuickLink[] = [
  {
    title: "电影作品",
    desc: "从出道作到年度新片，一览濑户环奈的大银幕旅程。",
    count: "6 部作品",
    to: "/works?type=电影",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20an%20elegant%20dress%2C%20soft%20warm%20studio%20lighting%2C%20sakura%20pink%20and%20cream%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=800&height=1000&seq=quick-01&orientation=portrait",
  },
  {
    title: "电视剧集",
    desc: "情感、职场、都市群像，见证她在小荧幕上的多面魅力。",
    count: "5 部作品",
    to: "/works?type=电视剧",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20soft%20indoor%20light%2C%20warm%20neutral%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=800&height=1000&seq=quick-02&orientation=portrait",
  },
  {
    title: "最新作品",
    desc: "按时间排序，第一时间了解濑户环奈的最新影视动向。",
    count: "持续更新",
    to: "/works?sort=最新",
    icon: "ri-sparkling-line",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20flowing%20natural%20clothing%2C%20soft%20dreamy%20lighting%2C%20sage%20green%20and%20cream%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=800&height=1000&seq=quick-03&orientation=portrait",
  },
];

export default function WorksQuickLinks() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
            <div>
              <span className="text-xs font-medium tracking-[0.2em] text-primary-500 uppercase">
                Works
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
                影视作品快捷入口
              </h2>
            </div>
            <Link
              to="/works"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
            >
              查看全部作品
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {quickLinks.map((item) => (
              <Link
                key={item.title}
                to={item.to}
                className="group relative rounded-lg overflow-hidden h-72 cursor-pointer"
              >
                <img
                  src={item.image}
                  alt={`${item.title}分类封面`}
                  title={`${item.title} - 濑户环奈影视作品`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent"></div>
                <div className="absolute inset-0 p-5 flex flex-col justify-end">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 mb-3">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <span className="text-xs text-background-200 mb-1">{item.count}</span>
                  <h3 className="font-heading text-xl font-semibold text-background-50 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-background-100/85 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}